import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const WorkspaceLink = ({
  profile,
  share,
}) => {
  const intl = useIntl();

  if (!profile) {
    return null;
  }

  const url = share.top_collection ? `/collections/${share.top_collection.uuid}` : '/';

  const viewMessage = share.top_collection ?
    intl.formatMessage({ defaultMessage: 'View in workspace' }) :
    intl.formatMessage({ defaultMessage: 'Go to workspace' });

  return (
    <NavItem>
      <NavLink
        tag={Link}
        to={url}
        id="go-to-workspace-icon"
        className="nav-go-to-workspace"
        aria-label={viewMessage}
      >
        <i className="far fa-arrow-up-right-from-square" />
      </NavLink>
      <UncontrolledTooltip fade={false} placement="bottom" target="go-to-workspace-icon">
        {viewMessage}
      </UncontrolledTooltip>
    </NavItem>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

WorkspaceLink.propTypes = {
  profile: PropTypes.object,
  share: PropTypes.object.isRequired,
};

WorkspaceLink.defaultProps = {
  profile: null,
};

export default withRouter(connect(mapStateToProps)(WorkspaceLink));
